import { createApp } from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import { loadFonts } from "./plugins/webfontloader";
import axios from "axios";
import VShowSlide from "vue-show-slide";

loadFonts();

const app = createApp(App);
app.provide(
  "$baseURL",
  process.env.NODE_ENV === "development"
    ? "https://dgpub.282.co.kr:8502/api/"
    : "https://ext.daeguro.co.kr:45010/api/"
);
app.config.globalProperties.$axios = axios;
axios.defaults.baseURL =
  process.env.NODE_ENV === "development"
    ? "https://dgpub.282.co.kr:8502/api/"
    : "https://ext.daeguro.co.kr:45010/api/";
app.use(VShowSlide);
app.use(vuetify).mount("#app");
